export interface LoginsApiClientParams {
  sessionToken: string;
  loginsUrl: string;
  hubSlug: string;
}

export class LoginsApiClient {
  readonly sessionToken: string;
  readonly loginsUrl: string;
  readonly hubSlug: string;

  constructor({ sessionToken, loginsUrl, hubSlug }: LoginsApiClientParams) {
    this.sessionToken = sessionToken;
    this.loginsUrl = loginsUrl;
    this.hubSlug = hubSlug;
  }

  toJSON() {
    return { sessionToken: this.sessionToken, loginsUrl: this.loginsUrl, hubSlug: this.hubSlug }
  }

  async prolongSession() {
    const url = new URL(`/${this.hubSlug}/login/prolong`, this.loginsUrl);
    const response = await fetch(url, {
      headers: this.headers,
    });
    if (!response.ok) throw await response.text()
  }

  async requestIdentityToken(): Promise<string> {
    const url = new URL(`/${this.hubSlug}/login/request_identity_token`, this.loginsUrl);
    const response = await fetch(url, {
      method: "POST",
      headers: this.headers,
    });
    return await response.json();
  }

  signOutUrl(reason?: string): URL {
    const url = new URL(`/${this.hubSlug}/logout`, this.loginsUrl);

    if (reason) { url.searchParams.set("reason", reason) }

    return url;
  }

  private get headers() {
    return {
      Accept: "application/json",
      Authorization: `Bearer ${this.sessionToken}`,
    }
  }
}
